import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Artwork} from "../../models/artwork";
import {MessagesService} from "../../services/messages/messages.service";
import {RouteService} from "../../services/route/route.service";
import {Media} from "../../models/media";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-route-artwork-modal',
    templateUrl: './route-artwork-modal.component.html',
    styleUrls: ['./route-artwork-modal.component.scss']
})
export class RouteArtworkModal {

    @Input() projectId: string;
    @Input() databaseId: string;
    @Input() routeId: string;
    @Input() code: string;
    @Input() artworks: Array<Artwork>;
    @Input() media: Array<Media>;

    @Output() addArtworkEmitter: EventEmitter<string[]> = new EventEmitter();

    artworkIds: string[] = [];

    constructor(
        public activeModal: NgbActiveModal,
    ) {
    }

    toggleSelect(artworkId: string): void {
        const index = this.artworkIds.findIndex(id => id === artworkId);
        if (index >= 0) {
            this.artworkIds.splice(index, 1);
        } else {
            this.artworkIds.push(artworkId);
        }
    }

    submitArtwork() {
        if (this.artworkIds.length > 0) {
            this.addArtworkEmitter.emit(this.artworkIds);
        }
    }

    getImage(artwork: Artwork): string {
        const media = this.media.find(({_id}) => _id === artwork.image_cover);
        return media ? `${environment.museonPieServer}/media/${media.uri}?museum_id=${this.code}` : '';
    }
}
